/**
 * Match a route pattern (with :param segments) against an actual pathname.
 * Uses prefix matching: pattern `/a/:id` matches `/a/123` and `/a/123/edit`.
 */
export function matchPath(pattern: string, pathname: string): boolean {
  const patternParts = pattern.replace(/\/$/, '').split('/').filter(Boolean);
  const pathParts = pathname.replace(/\/$/, '').split('/').filter(Boolean);

  if (pathParts.length < patternParts.length) return false;

  for (let i = 0; i < patternParts.length; i++) {
    if (patternParts[i]!.startsWith(':')) continue;
    if (patternParts[i] !== pathParts[i]) return false;
  }

  return true;
}
